export function forEachElement<E extends HTMLElement>(
  selectors: string,
  callback: (elem: E, index: number) => void,
  rootElement?: ParentNode,
) {
  Array.prototype.forEach.call(allElements(selectors, rootElement), callback);
}

export function allElements<E extends HTMLElement>(selector: string, rootElement?: ParentNode | null) {
  return (rootElement || document).querySelectorAll<E>(selector);
}

export function replaceNode(node: HTMLElement, rule: string, html: string) {
  /*                                 */
  const range = document.createRange();
  range.selectNodeContents(node);

  /*                                                               */
  const fragment = range.createContextualFragment(html);

  /*           */
  range.deleteContents();
  range.insertNode(fragment);

  /*                     */
  node.dataset.rule = rule;
}
